import { type ClassName, tw, twx } from '@ctw/shared/utils/tailwind';
import {
  faCircleInfo,
  faExclamationCircle,
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';

export type AlertProps = {
  header?: string;
  children?: ReactNode;
  className?: ClassName;
  type: 'error' | 'caution' | 'info';
};

const TYPE_STYLES = {
  error: {
    icon: faExclamationCircle,
    background: tw`bg-error-background`,
    text: tw`text-error-text`,
  },
  caution: {
    icon: faExclamationTriangle,
    background: tw`bg-caution-badge`,
    text: tw`text-caution-text`,
  },
  info: {
    icon: faCircleInfo,
    background: tw`bg-info-background`,
    text: tw`text-info-text`,
  },
} as const;

export const Alert = ({ header, children, className, type }: AlertProps) => {
  const styles = TYPE_STYLES[type];
  return (
    <div
      className={twx(
        'flex items-start space-x-2 rounded-md p-4 text-left shadow-sm',
        styles.background,
        className,
      )}
    >
      <FontAwesomeIcon icon={styles.icon} className={twx('h-5 flex-none', styles.text)} />
      <div className={tw`space-y-2`}>
        {header && <div className={twx('font-medium', styles.text)}>{header}</div>}
        {children && <div className={twx(styles.text)}>{children}</div>}
      </div>
    </div>
  );
};
